import React from 'react';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
import { contacts, facilityData } from '../data/mock';

const ContactSection = ({ onRequestQuote }) => {
  return (
    <section id="contact" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <div className="section-header" style={{ marginBottom: '40px' }}>
              <p className="section-label">Get in Touch</p>
              <h2 className="section-title">Let's Discuss Your Requirements</h2>
              <p className="section-description">
                Our team of experts is ready to help you find the perfect fastening 
                solutions for your manufacturing needs.
              </p>
            </div>

            {/* Facility Info */}
            <div 
              className="p-6 mb-8"
              style={{ background: 'var(--bg-primary)', borderLeft: '3px solid var(--accent-teal)' }}
            >
              <h4 className="heading-3 mb-4 flex items-center gap-2">
                <MapPin size={18} style={{ color: 'var(--accent-teal)' }} />
                Visit Our Facility
              </h4>
              <p className="body-regular mb-2">{facilityData.location}</p>
              <p className="body-small">
                {facilityData.total_area_sqft.toLocaleString()} sq. ft. total area | 
                {' '}{facilityData.built_up_area_sqft.toLocaleString()} sq. ft. built-up
              </p>
            </div>

            <button className="btn-primary" onClick={onRequestQuote}>
              Send Us Your Inquiry
              <ArrowRight size={14} />
            </button>
          </div>

          <div>
            <h3 className="heading-3 mb-6">Contact Our Directors</h3>
            <div className="space-y-4">
              {contacts.map((contact, index) => (
                <div key={index} className="contact-card">
                  <h4 className="contact-name">{contact.name}</h4>
                  <p className="contact-title">{contact.title}</p>
                  <div className="contact-info">
                    <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="contact-link">
                      <Phone size={16} />
                      {contact.phone}
                    </a>
                    <a href={`mailto:${contact.email}`} className="contact-link">
                      <Mail size={16} />
                      {contact.email}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
